import { FC, memo } from 'react';

import { AttachmentKind } from '../../../data/AttachmentKind';
import FileList from '../../filesSection/FileList/FileList';
import { Root } from './AttachmentCell.styles';
import { AttachmentCellProps } from './AttachmentCell.types';

const AttachmentCell: FC<AttachmentCellProps> = memo((props) => {
    const { className, onClickOnAttachment, attachment, isLoading, invalid, onRemoveAttachment } = props;

    return (
        <Root className={className} $invalid={invalid}>
            <FileList
                maxFilesCount={1}
                attachments={!isLoading && attachment ? [attachment] : []}
                newAttachments={isLoading && attachment ? [attachment] : []}
                attachmentKind={AttachmentKind.ExpenseReportLineAttachment}
                removeAttachment={onRemoveAttachment}
                customHandleClickOnAttachment={onClickOnAttachment}
            />
        </Root>
    );
});

export default AttachmentCell;
